import axiosClient from "../axios/axiosClient";

export function getFocusAreas() {
  return axiosClient.get("/focus-areas");
}

export function getFocusArea(focusAreaId) {
  return axiosClient.get(`/focus-areas/${focusAreaId}`);
}

export function createFocusArea(data) {
  return axiosClient.post("/focus-areas", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updateFocusArea = (focusAreaId, data) => {
  return axiosClient.put(`/focus-areas/${focusAreaId}`, data);
};

export function deleteFocusArea(focusAreaId) {
  return axiosClient.delete(`/focus-areas/${focusAreaId}`);
}
